export default {
  assignedToMe: 'Mir zugewiesen',
  selectInReviewState: 'Aufgaben zur Überprüfung auswählen',
};
